var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Words"},_vm._l((_vm.words),function(w,k){return _c('Word',{key:w,attrs:{"pos":_vm.pos[k],"id":k,"txt":w,"color":_vm.colors[k],"description":_vm.descriptions[k]}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-826af202","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/defis/components/Words.vue
// module id = null
// module chunks = 